import { Container, Logo, PageName } from "./style";

import { useEffect, useState } from "react";
import { useLocation} from "react-router";
import { IHU } from "../../Interfaces"
import {useHabUnits} from "../../Providers/HabUnit";

interface IHeaderProps {
  page?: string;
}

const Header = ({ page }: IHeaderProps) => {
  const [pathName, setPathName] = useState<string>("");
  const [currentHU, setCurrentHU] = useState<IHU>();
  const { AdmHUList } = useHabUnits();
  const { pathname } = useLocation();
  
  const id  = pathname.replace(/[^0-9]/g,'');

  useEffect(() => {
    setPathName(pathname)
    setCurrentHU(AdmHUList.find((el) => el.id === Number(id)));
  }, [pathname, AdmHUList, currentHU, id]);

  return (
    <Container>
      {pathName === "/" ||
      pathName === "/dashboard" ||
      pathName === "/about_us" ? (
        <Logo />
      ) : (
        <PageName>
          {(!!page === true && { page }) ||
            (pathName === "/guests" && "Hóspedes") ||
            (pathName === "/unitHabits" && "Unidades Habitacionais") ||
            (pathName === "/products_services" && "Produtos e Serviços") ||
            (pathName === "/colaborators" && "Colaboradores") 
            || (pathName !== `/unitHabits/` && `Quarto ${currentHU?.title}`)
      }</PageName>
      )}
    </Container>
  );
};
export default Header;
